"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _logger = require("@insided/shared/services/logger");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _IntegrationSetup = _interopRequireDefault(require("./IntegrationSetup"));

var _axios = _interopRequireDefault(require("axios"));

var _Tabs = require("./components/freshdesk/Tabs");

var _PanelItems = require("./components/PanelItems");

var _UninstallModal = _interopRequireDefault(require("./components/UninstallModal"));

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _constants = require("@insided/shared/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Freshdesk = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Freshdesk, _Component);

  var _super = _createSuper(Freshdesk);

  function Freshdesk(props) {
    var _props$isInstalled, _props$isTicketCreati, _props$isFederatedSea, _props$apiKey, _props$subdomain, _props$isTicketCreati2, _props$isFederatedSea2, _props$apiKey2, _props$subdomain2;

    var _this;

    (0, _classCallCheck2.default)(this, Freshdesk);
    _this = _super.call(this, props);
    _this.state = {
      isInstalled: (_props$isInstalled = props.isInstalled) !== null && _props$isInstalled !== void 0 ? _props$isInstalled : false,
      isTicketCreationEnabled: (_props$isTicketCreati = props.isTicketCreationEnabled) !== null && _props$isTicketCreati !== void 0 ? _props$isTicketCreati : false,
      isFederatedSearchEnabled: (_props$isFederatedSea = props.isFederatedSearchEnabled) !== null && _props$isFederatedSea !== void 0 ? _props$isFederatedSea : false,
      apiKey: (_props$apiKey = props.apiKey) !== null && _props$apiKey !== void 0 ? _props$apiKey : '',
      subdomain: (_props$subdomain = props.subdomain) !== null && _props$subdomain !== void 0 ? _props$subdomain : '',
      showActionButtons: false,
      storedState: {
        isTicketCreationEnabled: (_props$isTicketCreati2 = props.isTicketCreationEnabled) !== null && _props$isTicketCreati2 !== void 0 ? _props$isTicketCreati2 : false,
        isFederatedSearchEnabled: (_props$isFederatedSea2 = props.isFederatedSearchEnabled) !== null && _props$isFederatedSea2 !== void 0 ? _props$isFederatedSea2 : false,
        apiKey: (_props$apiKey2 = props.apiKey) !== null && _props$apiKey2 !== void 0 ? _props$apiKey2 : '',
        subdomain: (_props$subdomain2 = props.subdomain) !== null && _props$subdomain2 !== void 0 ? _props$subdomain2 : ''
      },
      activeTab: 0,
      showUnsavedChangesModal: false,
      showUninstallModal: false,
      isSyncInProgress: false,
      destination: props.destination
    };
    _this.onTicketCreationSettingChanged = _this.onTicketCreationSettingChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onFederatedSearchSettingChanged = _this.onFederatedSearchSettingChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetTicketCreationSetting = _this.resetTicketCreationSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.saveTicketCreationSetting = _this.saveTicketCreationSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.onInstall = _this.onInstall.bind((0, _assertThisInitialized2.default)(_this));
    _this.onUninstall = _this.onUninstall.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickUninstallButton = _this.onClickUninstallButton.bind((0, _assertThisInitialized2.default)(_this));
    _this.closeUninstallModal = _this.closeUninstallModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.onResetInstallationTab = _this.onResetInstallationTab.bind((0, _assertThisInitialized2.default)(_this));
    _this.onResetIntegrationTab = _this.onResetIntegrationTab.bind((0, _assertThisInitialized2.default)(_this));
    _this.setActiveTab = _this.setActiveTab.bind((0, _assertThisInitialized2.default)(_this));
    _this.setSelectedPanel = _this.setSelectedPanel.bind((0, _assertThisInitialized2.default)(_this));
    _this.closeModal = _this.closeModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.displayUnsavedChangedModal = _this.displayUnsavedChangedModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.removeValidationErrorFromInputField = _this.removeValidationErrorFromInputField.bind((0, _assertThisInitialized2.default)(_this));
    _this.dismissMessage = _this.dismissMessage.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSync = _this.onSync.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Freshdesk, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setState({
        messageType: undefined
      });
      window.addEventListener('beforeunload', function (e) {
        return _this2.onUnload(e);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('beforeunload', this.onUnload);
    }
  }, {
    key: "onUnload",
    value: function onUnload(e) {
      if (this.checkPanelHasUnsavedChanges()) {
        e.preventDefault();
        e.returnValue = '';
      }
    }
  }, {
    key: "checkPanelHasUnsavedChanges",
    value: function checkPanelHasUnsavedChanges() {
      var _this$state = this.state,
          apiKey = _this$state.apiKey,
          subdomain = _this$state.subdomain,
          isTicketCreationEnabled = _this$state.isTicketCreationEnabled,
          isFederatedSearchEnabled = _this$state.isFederatedSearchEnabled;
      var hasApiKeyChanged = apiKey !== this.state.storedState.apiKey;
      var hasSubdomainChanged = subdomain !== this.state.storedState.subdomain;
      var hasTicketCreationSettingChanged = isTicketCreationEnabled !== this.state.storedState.isTicketCreationEnabled;
      var hasFederatedSearchSettingChanged = isFederatedSearchEnabled !== this.state.storedState.isFederatedSearchEnabled;
      return hasApiKeyChanged || hasSubdomainChanged || hasTicketCreationSettingChanged || hasFederatedSearchSettingChanged;
    }
  }, {
    key: "setSelectedPanel",
    value: function setSelectedPanel(selectedPanel) {
      this.setState({
        selectedPanel: selectedPanel
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        showUnsavedChangesModal: false
      });
    }
  }, {
    key: "onTicketCreationSettingChanged",
    value: function onTicketCreationSettingChanged(value) {
      this.setState({
        isTicketCreationEnabled: value,
        showActionButtons: true
      });
    }
  }, {
    key: "onFederatedSearchSettingChanged",
    value: function onFederatedSearchSettingChanged(val) {
      this.setState({
        isFederatedSearchEnabled: val,
        showActionButtons: true
      });
    }
  }, {
    key: "resetTicketCreationSetting",
    value: function resetTicketCreationSetting() {
      this.setState({
        isTicketCreationEnabled: this.state.storedState.isTicketCreationEnabled,
        showActionButtons: false,
        showUnsavedChangesModal: false
      });
    }
  }, {
    key: "resetFederatedSearchSetting",
    value: function resetFederatedSearchSetting() {
      this.setState({
        isFederatedSearchEnabled: this.state.storedState.isFederatedSearchEnabled,
        showActionButtons: false,
        showUnsavedChangesModal: false
      });
    }
  }, {
    key: "onResetIntegrationTab",
    value: function onResetIntegrationTab(activeTab) {
      this.resetTicketCreationSetting();
      this.resetFederatedSearchSetting();
      this.setState({
        activeTab: activeTab
      });
    }
  }, {
    key: "setActiveTab",
    value: function setActiveTab(selectedTab) {
      if (this.checkPanelHasUnsavedChanges()) {
        this.setState({
          showUnsavedChangesModal: true
        });
        return;
      }

      this.setState({
        activeTab: selectedTab
      });
    }
  }, {
    key: "saveTicketCreationSetting",
    value: function () {
      var _saveTicketCreationSetting = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var successMessage, errorMessage, isTicketCreationEnabled, requestUrl, response, updatedState;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  messageType: undefined,
                  showWarningMessage: false,
                  isSavingTicketCreationSetting: true
                });
                successMessage = 'Changes are saved successfully.';
                errorMessage = "Something went wrong, setting can't be updated. Please try again.";
                isTicketCreationEnabled = this.state.isTicketCreationEnabled;
                requestUrl = '/integration/freshdesk/ticket/disable';

                if (isTicketCreationEnabled) {
                  requestUrl = '/integration/freshdesk/ticket/enable';
                }

                _context.prev = 6;
                _context.next = 9;
                return _axios.default.put(requestUrl);

              case 9:
                response = _context.sent;
                updatedState = _objectSpread({}, this.state.storedState);
                updatedState.isTicketCreationEnabled = isTicketCreationEnabled;

                if (response.status === 200) {
                  this.setState({
                    showWarningMessage: response.data.showWarningMessage
                  });
                }

                this.setState({
                  storedState: updatedState,
                  message: successMessage,
                  messageType: 'success',
                  showActionButtons: false,
                  isSavingTicketCreationSetting: false
                });

                _publish.default.trackEvent('userevent', {
                  type: "Create Freshdesk tickets from community posts ".concat(isTicketCreationEnabled ? 'enabled' : 'disabled')
                });

                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](6);
                this.setState({
                  messageType: 'error',
                  message: errorMessage,
                  showActionButtons: false,
                  showWarningMessage: false,
                  isSavingTicketCreationSetting: false,
                  isTicketCreationEnabled: this.state.storedState.isTicketCreationEnabled
                });

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 17]]);
      }));

      function saveTicketCreationSetting() {
        return _saveTicketCreationSetting.apply(this, arguments);
      }

      return saveTicketCreationSetting;
    }()
  }, {
    key: "saveFederatedSearchSetting",
    value: function () {
      var _saveFederatedSearchSetting = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var successMessage, errorMessage, isFederatedSearchEnabled, requestUrl, response, updatedState;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  messageType: undefined,
                  showWarningMessage: false,
                  isSavingFederatedSearchSetting: true
                });
                successMessage = 'Changes are saved successfully.';
                errorMessage = "Something went wrong, setting can't be updated. Please try again.";
                isFederatedSearchEnabled = this.state.isFederatedSearchEnabled;
                requestUrl = '/integration/freshdesk/search/disable';

                if (isFederatedSearchEnabled) {
                  requestUrl = '/integration/freshdesk/search/enable';
                }

                _context2.prev = 6;
                _context2.next = 9;
                return _axios.default.put(requestUrl);

              case 9:
                response = _context2.sent;
                updatedState = _objectSpread({}, this.state.storedState);
                updatedState.isFederatedSearchEnabled = isFederatedSearchEnabled;

                if (response.status === 200) {
                  this.setState({
                    showWarningMessage: response.data.showWarningMessage
                  });
                }

                this.setState({
                  storedState: updatedState,
                  message: successMessage,
                  messageType: 'success',
                  showActionButtons: false,
                  isSavingFederatedSearchSetting: false
                });

                _publish.default.trackEvent('userevent', {
                  type: "Federated search is ".concat(isFederatedSearchEnabled ? 'enabled.' : 'disabled.')
                });

                _context2.next = 20;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](6);
                this.setState({
                  messageType: 'error',
                  message: errorMessage,
                  showActionButtons: false,
                  showWarningMessage: false,
                  isSavingFederatedSearchSetting: false,
                  isFederatedSearchEnabled: this.state.storedState.isFederatedSearchEnabled
                });

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 17]]);
      }));

      function saveFederatedSearchSetting() {
        return _saveFederatedSearchSetting.apply(this, arguments);
      }

      return saveFederatedSearchSetting;
    }()
  }, {
    key: "onInstall",
    value: function () {
      var _onInstall = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var successMessage, errorMessage, _this$state2, apiKey, subdomain, validatedFields, data, result, _result$data, isEnabled, isInstalled, _apiKey, _subdomain, updatedStoredState, _data$error, _data;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setState({
                  messageType: undefined,
                  validationErrorMessage: undefined,
                  isSavingCredentials: true
                });
                successMessage = 'All set! Freshdesk installed.';
                errorMessage = "Something went wrong, credentials can't be saved. Please try again.";
                _this$state2 = this.state, apiKey = _this$state2.apiKey, subdomain = _this$state2.subdomain;
                validatedFields = [];

                if (apiKey === '') {
                  validatedFields.push('apiKey');
                }

                if (subdomain === '') {
                  validatedFields.push('subdomain');
                }

                if (!(validatedFields.length !== 0)) {
                  _context3.next = 10;
                  break;
                }

                this.setState({
                  errorFields: validatedFields,
                  validationErrorMessage: 'Please fill in the required field.',
                  isSavingCredentials: false
                });
                return _context3.abrupt("return");

              case 10:
                data = {
                  apiKey: apiKey,
                  subdomain: subdomain
                };
                _context3.prev = 11;
                _context3.next = 14;
                return _axios.default.post('/integration/freshdesk/install', data);

              case 14:
                result = _context3.sent;
                _result$data = result.data, isEnabled = _result$data.isEnabled, isInstalled = _result$data.isInstalled, _apiKey = _result$data.apiKey, _subdomain = _result$data.subdomain;
                updatedStoredState = _objectSpread({}, this.state.storedState);
                updatedStoredState.apiKey = _apiKey;
                updatedStoredState.subdomain = _subdomain;
                updatedStoredState.isTicketCreationEnabled = isEnabled;
                this.setState({
                  isInstalled: isInstalled,
                  apiKey: _apiKey,
                  subdomain: _subdomain,
                  isTicketCreationEnabled: isEnabled,
                  storedState: updatedStoredState,
                  message: successMessage,
                  messageType: 'success',
                  errorFields: [],
                  isSavingCredentials: false
                });

                _publish.default.trackEvent('userevent', {
                  type: 'Freshdesk app installed'
                });

                _context3.next = 28;
                break;

              case 24:
                _context3.prev = 24;
                _context3.t0 = _context3["catch"](11);
                _data = _context3.t0.response.data;
                this.setState({
                  validationErrorMessage: (_data$error = _data.error) !== null && _data$error !== void 0 ? _data$error : errorMessage,
                  errorFields: _data.error === 'The domain name entered seems invalid please check again.' ? ['subdomain'] : ['apiKey'],
                  isSavingCredentials: false
                });

              case 28:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[11, 24]]);
      }));

      function onInstall() {
        return _onInstall.apply(this, arguments);
      }

      return onInstall;
    }()
  }, {
    key: "onSync",
    value: function () {
      var _onSync = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var result, successMessage;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.setState({
                  isSyncInProgress: true,
                  messageType: undefined
                });
                _context4.prev = 1;
                _context4.next = 4;
                return _axios.default.put('/integration/freshdesk/search/sync');

              case 4:
                result = _context4.sent;
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                successMessage = "".concat(result.data.count, " Freshdesk articles are successfully synchronized!");
                this.setState({
                  isSyncInProgress: false,
                  messageType: 'success',
                  message: successMessage
                });
                _context4.next = 13;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](1);

                _logger.logger.error(_context4.t0, {
                  component: 'Freshdesk',
                  action: 'syncCategories'
                });

                this.setState({
                  isSyncInProgress: false,
                  messageType: 'error',
                  message: 'Sorry, synchronisation failed, please try again.'
                });

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 9]]);
      }));

      function onSync() {
        return _onSync.apply(this, arguments);
      }

      return onSync;
    }()
  }, {
    key: "onResetInstallationTab",
    value: function onResetInstallationTab(activeTab) {
      this.setState({
        apiKey: '',
        subdomain: '',
        validationErrorMessage: undefined,
        showUnsavedChangesModal: false,
        activeTab: activeTab
      });
    }
  }, {
    key: "displayUnsavedChangedModal",
    value: function displayUnsavedChangedModal() {
      this.setState({
        showUnsavedChangesModal: true
      });
    }
  }, {
    key: "onUninstall",
    value: function () {
      var _onUninstall = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var errorMessage, updatedStoredState, _data$error2, data;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.setState({
                  messageType: undefined
                });
                errorMessage = "Something went wrong, credentials can't be uninstalled. Please try again.";
                _context5.prev = 2;
                _context5.next = 5;
                return _axios.default.put('/integration/freshdesk/uninstall');

              case 5:
                updatedStoredState = _objectSpread({}, this.state.storedState);
                updatedStoredState.isTicketCreationEnabled = false;
                updatedStoredState.apiKey = '';
                updatedStoredState.subdomain = '';
                this.setState({
                  isInstalled: false,
                  apiKey: '',
                  subdomain: '',
                  isTicketCreationEnabled: false,
                  storedState: updatedStoredState,
                  showUninstallModal: false
                });
                _context5.next = 16;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](2);
                data = _context5.t0.response.data;
                this.setState({
                  messageType: 'error',
                  message: (_data$error2 = data.error) !== null && _data$error2 !== void 0 ? _data$error2 : errorMessage,
                  showUninstallModal: false
                });

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[2, 12]]);
      }));

      function onUninstall() {
        return _onUninstall.apply(this, arguments);
      }

      return onUninstall;
    }()
  }, {
    key: "onClickUninstallButton",
    value: function onClickUninstallButton() {
      this.setState({
        showUninstallModal: true
      });
    }
  }, {
    key: "closeUninstallModal",
    value: function closeUninstallModal() {
      this.setState({
        showUninstallModal: false
      });
    }
  }, {
    key: "removeValidationErrorFromInputField",
    value: function removeValidationErrorFromInputField(inputField) {
      var _this$state$errorFiel;

      if ((_this$state$errorFiel = this.state.errorFields) !== null && _this$state$errorFiel !== void 0 && _this$state$errorFiel.includes(inputField)) {
        var _this$state$errorFiel2;

        var fields = (_this$state$errorFiel2 = this.state.errorFields) === null || _this$state$errorFiel2 === void 0 ? void 0 : _this$state$errorFiel2.filter(function (value) {
          return value !== inputField;
        });
        this.setState({
          errorFields: fields
        });
      }
    }
  }, {
    key: "dismissMessage",
    value: function dismissMessage() {
      this.setState({
        messageType: undefined,
        message: ''
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state3 = this.state,
          isInstalled = _this$state3.isInstalled,
          isTicketCreationEnabled = _this$state3.isTicketCreationEnabled,
          isFederatedSearchEnabled = _this$state3.isFederatedSearchEnabled,
          activePanel = _this$state3.activePanel,
          messageType = _this$state3.messageType,
          message = _this$state3.message,
          activeTab = _this$state3.activeTab,
          apiKey = _this$state3.apiKey,
          subdomain = _this$state3.subdomain,
          validationErrorMessage = _this$state3.validationErrorMessage,
          storedState = _this$state3.storedState,
          showActionButtons = _this$state3.showActionButtons,
          showUnsavedChangesModal = _this$state3.showUnsavedChangesModal,
          showUninstallModal = _this$state3.showUninstallModal,
          errorFields = _this$state3.errorFields,
          showWarningMessage = _this$state3.showWarningMessage,
          isSavingCredentials = _this$state3.isSavingCredentials,
          isSavingTicketCreationSetting = _this$state3.isSavingTicketCreationSetting,
          isSavingFederatedSearchSetting = _this$state3.isSavingFederatedSearchSetting,
          isSyncInProgress = _this$state3.isSyncInProgress,
          destination = _this$state3.destination;
      var panelHasUnsavedChanges = this.checkPanelHasUnsavedChanges();
      var enabledIntegrationCount = this.state.storedState.isTicketCreationEnabled ? 1 : 0;
      return (0, _preact.h)(_IntegrationSetup.default, {
        headerTitle: "Freshdesk",
        appLogoName: "freshdesk-l",
        appContainerBackgroundColor: "#25C16F",
        dismissMessage: this.dismissMessage,
        messageType: messageType,
        message: message,
        installButton: isInstalled ? (0, _preact.h)(_PanelItems.InstallAndUninstallButtons, {
          onClickUninstallButton: function onClickUninstallButton() {
            return _this3.onClickUninstallButton();
          }
        }) : (0, _preact.h)(_Button.default, {
          size: "medium",
          variant: "brand",
          title: "Install now",
          className: "installation__button_cta",
          onClick: function onClick() {
            return _this3.setActiveTab(1);
          }
        }),
        description: (0, _preact.h)(OverviewDescriptionText, null),
        tabTitles: ['Integration', 'Installation'],
        activeTab: activeTab,
        onClickTab: function onClickTab(selectedTab) {
          return _this3.setActiveTab(selectedTab);
        },
        tabContents: [(0, _preact.h)(_Tabs.IntegrationTab, {
          key: "integrationTab",
          storedState: storedState,
          activePanel: activePanel,
          isInstalled: isInstalled,
          isTicketCreationSettingEnabled: isTicketCreationEnabled,
          isFederatedSearchEnabled: isFederatedSearchEnabled,
          showActionButtons: showActionButtons,
          onSaveTicketCreationSetting: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
            return _regenerator.default.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return _this3.saveTicketCreationSetting();

                  case 2:
                    return _context6.abrupt("return", _context6.sent);

                  case 3:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6);
          })),
          onSaveFederatedSearchSetting: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
            return _regenerator.default.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.next = 2;
                    return _this3.saveFederatedSearchSetting();

                  case 2:
                    return _context7.abrupt("return", _context7.sent);

                  case 3:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7);
          })),
          onResetTicketCreationSetting: function onResetTicketCreationSetting() {
            return _this3.resetTicketCreationSetting();
          },
          onResetFederatedSearchSetting: function onResetFederatedSearchSetting() {
            return _this3.resetFederatedSearchSetting();
          },
          onTicketCreationSettingChanged: function onTicketCreationSettingChanged() {
            return _this3.onTicketCreationSettingChanged(!isTicketCreationEnabled);
          },
          onFederatedSearchSettingChanged: function onFederatedSearchSettingChanged() {
            return _this3.onFederatedSearchSettingChanged(!isFederatedSearchEnabled);
          },
          hasUnsavedChanges: panelHasUnsavedChanges,
          showUnsavedChangesModal: showUnsavedChangesModal,
          displayUnsavedChangedModal: function displayUnsavedChangedModal() {
            return _this3.displayUnsavedChangedModal();
          },
          closeModal: function closeModal() {
            return _this3.closeModal();
          },
          resetChanges: function resetChanges() {
            return _this3.onResetIntegrationTab(0);
          },
          showWarningMessage: showWarningMessage,
          isSavingTicketCreationSetting: isSavingTicketCreationSetting,
          isSavingFederatedSearchSetting: isSavingFederatedSearchSetting,
          onClickPanelCallback: function onClickPanelCallback(selectedPanel) {
            return _this3.setSelectedPanel(selectedPanel);
          },
          isSyncInProgress: isSyncInProgress,
          onSyncArticles: this.onSync,
          destination: destination
        }), (0, _preact.h)(_Tabs.InstallationTab, {
          key: "installationTab",
          apiKey: apiKey,
          subdomain: subdomain,
          isInstalled: isInstalled,
          onSave: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8() {
            return _regenerator.default.wrap(function _callee8$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    _context8.next = 2;
                    return _this3.onInstall();

                  case 2:
                    return _context8.abrupt("return", _context8.sent);

                  case 3:
                  case "end":
                    return _context8.stop();
                }
              }
            }, _callee8);
          })),
          onCancel: function onCancel() {
            return _this3.onResetInstallationTab(1);
          },
          onApiKeyChangeCallback: function onApiKeyChangeCallback(value) {
            return _this3.setState({
              apiKey: value
            });
          },
          onApiKeyClickCallback: function onApiKeyClickCallback() {
            _this3.removeValidationErrorFromInputField('apiKey');
          },
          onSubdomainChangeCallback: function onSubdomainChangeCallback(value) {
            return _this3.setState({
              subdomain: value
            });
          },
          onSubdomainClickCallback: function onSubdomainClickCallback() {
            return _this3.removeValidationErrorFromInputField('subdomain');
          },
          onClickManage: function onClickManage() {
            return _this3.setActiveTab(0);
          },
          onClickUninstall: function onClickUninstall() {
            return _this3.onClickUninstallButton();
          },
          errorMessage: validationErrorMessage,
          errorFields: errorFields,
          hasUnsavedChanges: panelHasUnsavedChanges,
          showUnsavedChangesModal: showUnsavedChangesModal,
          displayUnsavedChangedModal: function displayUnsavedChangedModal() {
            return _this3.displayUnsavedChangedModal();
          },
          closeModal: function closeModal() {
            return _this3.closeModal();
          },
          resetChanges: function resetChanges() {
            return _this3.onResetInstallationTab(1);
          },
          isSavingCredentials: isSavingCredentials
        })],
        uninstallModal: (0, _preact.h)(_UninstallModal.default, {
          headerTitle: "Freshdesk",
          onUninstall: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
            return _regenerator.default.wrap(function _callee9$(_context9) {
              while (1) {
                switch (_context9.prev = _context9.next) {
                  case 0:
                    _context9.next = 2;
                    return _this3.onUninstall();

                  case 2:
                    return _context9.abrupt("return", _context9.sent);

                  case 3:
                  case "end":
                    return _context9.stop();
                }
              }
            }, _callee9);
          })),
          showUninstallModal: showUninstallModal,
          closeUninstallModal: function closeUninstallModal() {
            return _this3.closeUninstallModal();
          },
          enabledIntegrationCount: enabledIntegrationCount
        })
      });
    }
  }]);
  return Freshdesk;
}(_preact.Component);

var OverviewDescriptionText = function OverviewDescriptionText() {
  return (0, _preact.h)("div", null, "With Freshdesk, you can streamline all your customer conversations in one place, automate your repetitive work and save time, and collaborate with other teams to resolve issues faster.", (0, _preact.h)("div", {
    className: "description-details"
  }, "With Gainsight ", _constants.PLATFORM_BRAND_NAME_POSSESSIVE_FORM, " Freshdesk integrations, you can:", ' '), (0, _preact.h)("div", {
    className: "description-details"
  }, (0, _preact.h)("ul", null, (0, _preact.h)("li", null, "Quickly create Freshdesk tickets from any community post on ", _constants.PLATFORM_BRAND_NAME, ". Get users the 1-1 support they need if a post contains a question or problem that can\u2019t be directly resolved by other community members or the community moderation team."), (0, _preact.h)("li", null, "Enable community members to simultaneously search through your community content and Freshdesk knowledge base on ", _constants.PLATFORM_BRAND_NAME, ". Save users time and increase your self-service resolution rate."))));
};

var _default = Freshdesk;
exports.default = _default;